import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ElnatLista = lazy(() => import("@/pages/content/ElnatLista"));

export const Route = createFileRoute("/elnat/")({
  head: () => seoHead("/elnat", { description: "Hitta information om Sveriges elnätsbolag och deras nätområden, avgifter och villkor." }),
  component: () => <ElnatLista />,
});
